/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { Link } from "gatsby"
import * as React from "react"
import { motion } from "framer-motion"

/* -------------------------------------------------------------------------- */
/*                             External Components                            */
/* -------------------------------------------------------------------------- */
import Disclosures from "@components/global/disclosures"

/* -------------------------------------------------------------------------- */
/*                              Default Component                             */
/* -------------------------------------------------------------------------- */
export default function ConsentPopup(props) {
  return (
    <motion.div
      initial={props.modalInitial || { opacity: 0 }}
      animate={
        props.modalAnimate || {
          opacity: 1,
        }
      }
      exit={
        props.modalExit || {
          opacity: 0,
          transition: {
            duration: 0.2,
          },
        }
      }
      transition={props.modalTransition || { duration: 0.2 }}
      className="bg-grey-1 flex flex-col gap-[30px] items-center max-w-[660px] [padding:35px_60px] relative rounded-[12px] w-full"
    >
      <h3 className="font-variant-numeric--primary sans text-baltic-blue">
        Terms and conditions
      </h3>
      <div className="[&_*]:font-variant-numeric--primary [&_*]:leading-[21px] [&_*]:mb-0 [&_*]:text-[14px] [&_*]:text-grey-6 [&_a]:text-pacific-blue [&_a]:underline [&_*:last-child]:mb-0">
        <Disclosures disclosure="sms" />
      </div>

      {/* Buttons Container */}
      <div className="flex flex-wrap gap-[30px] justify-between max-w-[490px] min-w-fit [&_*]:font-bold [&_*]:max-w-[328px] [&_*]:w-fit">
        <button
          className="button button--primary  font-bold w-full"
          onClick={() => {
            props.updateConsentFieldValue(true)
            props.closeModal()
          }}
        >
          Agree and Continue
        </button>
        <button
          className="button button--tertiary bg-white font-bold w-full"
          onClick={() => {
            props.closeModal()
          }}
        >
          Cancel
        </button>
      </div>
    </motion.div>
  )
}
